import { useState, useEffect } from 'react'
import { SectionBackgroundImage } from '../../Components/Global'
import { useLandingContext } from '../../Context'
import { Link } from 'react-router-dom'
import fireload from '../../Services/firebaseConection'
import Styled from './login.module.css'
import * as CG from '../../Components/Global'
import Loading from '../../Components/Loading'

function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [saveDatas, setSaveDatas] = useState(false)
    const useLanding = useLandingContext()

    useEffect(() => {
        fireload()
        useLanding.handleCheckedLocalStorage()
        useLanding.handleGetWebsiteSettings()
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {useLanding.loading && <Loading />}
            <SectionBackgroundImage className={Styled.section_container} background={useLanding.websiteSettings.background} >
                <Link to="/" className={Styled.container_logo}>
                    <img className={Styled.logo} src={useLanding.websiteSettings.logo.url} alt="Logo" />
                </Link>
                <form className={Styled.container_form} onSubmit={(e) => {
                    e.preventDefault()
                    useLanding.handleSignIn(email, password, saveDatas)
                    setEmail('')
                    setPassword('')
                }}>
                    <CG.H2 color="var(--white-normal);">Login</CG.H2>
                    <CG.InputText maxLength={100} placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} />
                    <CG.InputText maxLength={100} placeholder="Senha" type="password" value={password} onChange={e => setPassword(e.target.value)} />
                    <label className={Styled.save_login}>
                        <input type="checkbox" onChange={e => setSaveDatas(e.target.checked)} />
                        Salvar login
                    </label>
                    <CG.Button color="var(--white-normal);" height={3} type="submit">Entrar</CG.Button>
                </form>
            </SectionBackgroundImage>
        </>
    )
}

export default Login